var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascripticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H77V77H0V0Z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2462 64.3467L26.1385 60.7807C27.2754 62.7962 28.3095 64.5016 30.79 64.5016C33.1677 64.5016 34.6671 63.5716 34.6671 59.9538V35.3505H41.903V60.0561C41.903 67.5507 37.5098 70.9621 31.1001 70.9621C25.3116 70.9621 21.9516 67.9642 20.2458 64.3461M45.8333 63.5713L51.725 60.1602C53.2761 62.693 55.292 64.5537 58.858 64.5537C61.8565 64.5537 63.7683 63.0546 63.7683 60.987C63.7683 58.5062 61.8042 57.6273 58.4962 56.1805L56.6876 55.4045C51.4669 53.1826 48.0041 50.3914 48.0041 44.4991C48.0041 39.0718 52.1389 34.9366 58.6 34.9366C63.2001 34.9366 66.5081 36.5392 68.8855 40.7258L63.2513 44.3442C62.0105 42.1217 60.6672 41.2431 58.5997 41.2431C56.4804 41.2431 55.1365 42.587 55.1365 44.3442C55.1365 46.5149 56.4804 47.3941 59.5814 48.738L61.3903 49.5131C67.5413 52.1495 71.0042 54.8369 71.0042 60.8838C71.0042 67.397 65.8873 70.963 59.0129 70.963C52.2938 70.963 47.952 67.7585 45.833 63.5716",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascripticon);
export default __webpack_public_path__ + "static/media/javascripticon.508090c3e1cc25fd6919cdaf80837b9a.svg";
export { ForwardRef as ReactComponent };